const React = require('react');
const { ThemeProvider } = require('styled-components');

const { light } = require('../src/assets/styles/themes/light');

export function wrapRootElement({ element }) {
  return <ThemeProvider theme={light}> {element}</ThemeProvider>;
}
